import { Controller } from "@hotwired/stimulus"

// The P&L statement's filter bar is one GET form: every control submits it, so each view has a
// shareable URL. Picking a new period clears "Show by" so the page picks a sensible one for it.
// "Custom range" waits for the dates and the Apply button instead of submitting straight away.
export default class extends Controller {
  static targets = ["range", "custom"]

  submit() {
    this.element.requestSubmit()
  }

  rangeChanged() {
    if (this.rangeTarget.value === "custom") {
      this.customTarget.classList.remove("d-none")
      this.customTarget.querySelector("input")?.focus()
      return
    }

    this.element.querySelectorAll("input[name='date_from'], input[name='date_to']").forEach((input) => (input.value = ""))
    this.element.querySelectorAll("input[name='by']").forEach((input) => (input.checked = false))
    this.submit()
  }
}
